// removed by extract-text-webpack-plugin
module.exports = {"fieldset":"c-ContactDetailsForm__fieldset","addressReadOnly":"c-ContactDetailsForm__addressReadOnly"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/ContactDetailsForm/ContactDetailsForm.scss
// module id = 541
// module chunks = 0